import ExpandingTextarea from 'react-expanding-textarea'
import styled, { css } from 'styled-components'
import { textSize, textWeight } from 'lib/Text'

export const TextInput = styled.input<{ $compact?: boolean }>`
  ${(props) =>
    props.$compact
      ? css`
          ${textSize('ps')}
          ${textWeight('regular')}
          padding: 8px 12px;

          &:focus {
            padding: 7px 11px;
          }
        `
      : css`
          ${textSize('s')}
          ${textWeight('regular')}
          padding: 13px 20px;

          &:focus {
            padding: 12px 19px;
          }
        `}

  border: 1px solid var(--black-20);
  width: 100%;

  border-radius: var(--input-radius);
  appearance: none;
  box-shadow: none;

  &[type='color'] {
    all: unset;
    outline: none;
    border-radius: var(--input-radius);
    box-shadow: none;
    border: 1px solid var(--black-20);
    padding: 4px;
    height: 42px;
    width: 42px;
    &:focus {
      border: 1px solid black;
      box-shadow: 0 0 0 1px black;
    }
  }

  &:focus {
    outline: none;
    border: 2px solid black;
  }

  &::placeholder,
  &::-webkit-input-placeholder {
    color: var(--black-30);
  }
  &::-moz-placeholder {
    color: var(--black-30);
  }
  &:-ms-input-placeholder {
    color: var(--black-30);
  }

  &:disabled {
    background: var(--black-10);
    border-color: var(--black-20);
    color: var(--black-40);
    cursor: not-allowed;
  }
`

const textAreaStyles = css`
  ${textSize('s')}
  ${textWeight('regular')}
  border: 1px solid var(--black-20);
  width: 100%;
  padding: 16px;
  border-radius: var(--input-radius);
  appearance: none;
  box-shadow: none;
  resize: vertical;
  min-height: 150px;
  display: block;
  line-height: 26px;

  &:focus {
    outline: none;
    border: 2px solid black;
    padding: 15px;
  }

  &:disabled {
    background: #f9f9f9;
    border-color: #b5b5b5;
  }

  &::placeholder,
  &::-webkit-input-placeholder {
    color: var(--black-30);
    ${textSize('s')}
    ${textWeight('regular')}
    font-style: italic;
  }
  &::-moz-placeholder {
    color: var(--black-30);
    ${textSize('s')}
    ${textWeight('regular')}
    font-style: italic;
  }
  &:-ms-input-placeholder {
    color: var(--black-30);
    ${textSize('s')}
    ${textWeight('regular')}
    font-style: italic;
  }
`

const compactTextAreaStyles = css`
  ${textSize('ps')}
  padding: 12px 16px;

  &:focus {
    outline: none;
    border: 2px solid black;
    padding: 11px 15px;
  }

  &::placeholder,
  &::-webkit-input-placeholder,
  &::-moz-placeholder,
  &:-ms-input-placeholder {
    ${textSize('ps')}
  }
`

export const TextArea = styled.textarea<{ $compact?: boolean }>`
  ${textAreaStyles}

  ${(props) =>
    props.$compact &&
    css`
      ${compactTextAreaStyles}
    `}
`

export const GrowingTextArea = styled(ExpandingTextarea)<{ $compact?: boolean }>`
  ${textAreaStyles}
  max-height: 780px;
  resize: none;
  ${(props) =>
    props.$compact &&
    css`
      ${compactTextAreaStyles}
    `}
`

export const DateInput = styled(TextInput)<{ filled?: boolean }>`
  width: 220px;

  &::-webkit-datetime-edit {
    color: ${(props) => (props.filled ? 'var(--dark-grey)' : 'var(--light-grey)')};
  }

  &:focus::-webkit-datetime-edit {
    color: black;
  }

  &::-webkit-calendar-picker-indicator,
  &::-webkit-inner-spin-button {
    display: none;
  }
`
